import axios from "axios";

export default function AxiosAPI(
  requestLink,
  requestParameters = {},
  requestType = "POST",
  responseType = ""
) {
  return new Promise(function (resolve, reject) {
    let promise;

    // Get Request
    if (requestType === "GET") {
      let dataStr = "";

      Object.keys(requestParameters).forEach(key => {
        dataStr += key + "=" + requestParameters[key] + "&";
      });

      if (dataStr !== "") {
        dataStr = dataStr.substring(0, dataStr.lastIndexOf("&"));
        requestLink = requestLink + "?" + dataStr;
      }

      if (responseType) {
        promise = axios.get(requestLink);
      } else {
        promise = axios.get(requestLink, {
          responseType: "blob"
        });
      }
    }

    // Post Request
    else {
      promise = axios.post(requestLink, requestParameters);
    }

    // Promise Success
    promise
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        // Promise Error
        reject(error);
      });
  });
}
